import {
  getMySubjects,
  getItemsForMySubject,
  getAssigmentById,
  updateAssigmentTS,
  deleteAssigmentTS,
} from '@school_ify/schoolify-repository/src/teacher/repositories/teachingStructureRepository';
import {
  teacherInsertAssigmentUsers,
  insertAssigmentTS,
  teacherDeleteAssigmentUsers,
} from '@school_ify/schoolify-repository/src/teacher/repositories/assignmentRepository';
import {
  TeacherGetAllMyLeafsQueryVariables,
  TeacherGetMyTeachingStructureItemsQueryVariables,
  TeacherStudentsToAssignmentMutationVariables,
  TeacherDeleteAssignmentUserMutationVariables,
} from '@school_ify/schoolify-repository/src/teacher/types';

export default class Study {
  public async getMySubjects(variables: TeacherGetMyTeachingStructureItemsQueryVariables) {
    const subjects = await getMySubjects(variables);
    return subjects;
  }

  public async getTeachingStructureForSubject(variables: TeacherGetAllMyLeafsQueryVariables) {
    const itemsForMySubject = await getItemsForMySubject(variables);
    return itemsForMySubject;
  }

  public async getAssigmentById(variables) {
    const assignment = await getAssigmentById(variables);
    return assignment;
  }

  public async createAssigment(variables) {
    const insertedAssignment = await insertAssigmentTS(variables);
    return insertedAssignment;
  }

  public async deleteAssigmentUsers(variables: TeacherDeleteAssignmentUserMutationVariables) {
    const deletedAssignmentUser = await teacherDeleteAssigmentUsers(variables);
    return deletedAssignmentUser;
  }

  public async updateAssigment(variables) {
    const updatedAssignment = await updateAssigmentTS(variables);
    return updatedAssignment;
    // return await
  }

  public async insertStudents(variables: TeacherStudentsToAssignmentMutationVariables) {
    return teacherInsertAssigmentUsers(variables);
  }

  public async delete(id) {
    const deletedAssignemt = await deleteAssigmentTS({
      _eq: id,
    });
    return deletedAssignemt;
  }
}
